module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_15.c8da3489.pdf";